import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
// Redux
import { GetSetting } from "../../Admin/Redux/Setting";
// Social Media Icons
import facebookIcon from "../../Assets/ICONS/social-media/facebook.svg";
import instagramIcon from "../../Assets/ICONS/social-media/instagram.svg";
import linkedInIcon from "../../Assets/ICONS/social-media/linkedin.svg";
import tikTokIcon from "../../Assets/ICONS/social-media/tiktok.svg";
import twitterIcon from "../../Assets/ICONS/social-media/twitter.svg";
import copyrightIcon from "../../Assets/ICONS/social-media/copyright.svg";
import FooterLogoImage from "../../Assets/logo/footer-logo.svg";

//Translation
import { useTranslation } from "react-i18next";
import svg_icon from "../../Assets/svg_icon";

const Footer = () => {
  const { socialMedia } = useSelector((state) => state.setting);
  const { isLoggedIn, role } = useSelector((state) => state.auth);
  const { billing, contact } = useSelector((state) => state.setting);

  //Use
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (socialMedia === undefined) dispatch(GetSetting());
  }, []);

  useEffect(() => {
    if (contact === undefined) dispatch(GetSetting());
  }, [contact, dispatch]);

  const FooterData = [
    {
      title: t("footer.mainHead.yourAccount"),
      children: [
        {
          title: t("footer.subHead.manageProfile"),
          link: `${isLoggedIn === false ? "/auth/customer" : `${role === "customer" ? "customer/profile" : `${role}/profile`}`}`,
        },
        {
          title: `${isLoggedIn === false ? t("footer.subHead.manageAddress") : `${role === "customer" ? t("footer.subHead.manageAddress") : ``}`}`,
          link: `${isLoggedIn === false ? "/auth/customer" : `${role === "customer" ? "customer/profile#address" : ``}`}`,
        },
      ],
    },
    {
      title: t("footer.mainHead.yourBookings"),
      children: [
        {
          title: t("footer.subHead.modifyBooking"),
          link: `${isLoggedIn === false ? "booking" : `${role === "customer" ? "booking#upcoming" : `${role}/booking/#upcoming`}`}`,
        },
        {
          title: t("footer.subHead.cancelBooking"),
          link: `${isLoggedIn === false ? "booking" : `${role === "customer" ? "booking#cancelled" : `${role}/booking/#upcoming`}`}`,
        },
        {
          title: t("footer.subHead.manageActiveRental"),
          link: `${isLoggedIn === false ? "booking" : `${role === "customer" ? "booking#active" : `${role}/booking/#upcoming`}`}`,
        },
      ],
    },
    {
      title: t("footer.mainHead.products"),
      children: [
        {
          title: t("footer.subHead.carRent"),
          link: "car-rental",
        },
        {
          title: t("footer.subHead.ourLoc"),
          link: "our-locations",
        },
        {
          title: t("footer.subHead.deals"),
          link: "car-rental-deals",
        },
      ],
    },
    {
      title: t("footer.mainHead.help"),
      children: [
        {
          title: t("footer.subHead.help"),
          link: "help",
        },
        {
          title: t("footer.subHead.rentalInfo"),
          link: "rental-information",
        },
        {
          title: t("footer.subHead.paymentTerms"),
          link: "payment-and-reimbursement-terms",
        },
        {
          title: t("footer.subHead.career"),
          link: "career",
        },
      ],
    },
    {
      title: t("footer.mainHead.policy"),
      children: [
        {
          title: t("footer.subHead.cancellation"),
          link: "/cancellation",
        },
        {
          title: t("footer.subHead.damage"),
          link: "/damage",
        },
        {
          title: "GDPR",
          link: "/gdpr",
        },
        {
          title: t("footer.subHead.insurance"),
          link: "insurance",
        },
        {
          title: t("footer.subHead.liability"),
          link: "liability-waiver",
        },
      ],
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="Footer c-light-primary notranslate">
      <div className="container">
        <div className="row footerHeadingLink gy-4 mt-auto">
          {FooterData?.map((ele, index) => {
            return (
              <div className="col-12 col-sm-6 col-lg-4 footerSpace txt-primary order-1" key={index}>
                <h4 className={`mb-2 mb-sm-3 ff_bd f18 `}>{ele?.title}</h4>
                <ul className="m-0 p-0 footerLinkList">
                  {ele.children?.map((ele1, index1) => {
                    return (
                      <Link to={ele1?.link} className="text-decoration-none d-block" key={index1} onClick={() => window.scrollTo(0, 0)}>
                        {ele1?.title}
                      </Link>
                    );
                  })}
                </ul>
              </div>
            );
          })}
          <div className="col-12 col-sm-6 col-lg-4 footerSpace txt-primary order-1">
            <h4 className={`mb-2 mb-sm-3 ff_bd f18 `}>{t("footer.mainHead.contactUs")}</h4>
            <ul className="m-0 p-0 footerLinkList">
              <Link to={`tel:${contact?.support_phone}`} className="text-decoration-none d-flex align-items-center">
                <span className="me-2 cursor-pointer">{svg_icon?.Footer_Phone}</span>
                <span>
                  {contact?.support_country_code !== null ? `+${contact?.support_country_code}` : "+32"}&nbsp;
                  {contact?.support_phone}
                </span>
              </Link>
              <Link to={`mailto:${contact?.support_email}`} className="text-decoration-none d-flex align-items-center" onClick={() => window.scrollTo(0, 0)}>
                <span className="me-2 cursor-pointer">{svg_icon?.Footer_Email}</span>
                <span>{contact?.support_email}</span>
              </Link>
              <Link
                to={`https://maps.google.com/?q=${billing?.company_address}`}
                className="text-decoration-none d-flex align-items-center"
                target="_blank"
                onClick={() => window.scrollTo(0, 0)}
              >
                <span className="me-2 cursor-pointer">{svg_icon?.Footer_Location}</span>
                <span>{billing?.company_address}</span>
              </Link>
            </ul>
          </div>
          <div className="col-12 footer-logo mt-lg-3 text-center text-lg-start order-0 order-lg-2">
            <img src={FooterLogoImage} alt="" className="img-fluid mt-4 mt-sm-3 mt-md-0" style={{ width: "200px" }} />
          </div>
        </div>
        <hr className="mb-0" />
        <div className="row py-3 d-flex justify-content-center justify-content-lg-between">
          <div className="col-12 col-lg-9 d-flex justify-content-center justify-content-lg-start mb-3 mb-lg-0 flex-wrap">
            <span className="px-2 d-flex align-items-center txt-primary">
              <img src={copyrightIcon} alt="copyright" className="img-fluid me-1" /> {t("footer.labels.name")}
            </span>
            {[
              { to: "privacy-policy", label: "auth.string.privacyPolicy" },
              { to: "terms-and-conditions", label: "footer.labels.terms" },
              { to: "sitemap", label: "footer.labels.siteMap" },
            ].map((ele, index) => {
              return (
                <Link to={ele?.to} className="text-decoration-none px-2 border-start txt-primary" key={index} onClick={() => window.scrollTo(0, 0)}>
                  {t(ele?.label)}
                </Link>
              );
            })}
          </div>
          <div className="SocialMedia col-12 col-lg-3 d-flex justify-content-center justify-content-lg-end">
            {[
              { name: "facebook", image: facebookIcon },
              { name: "instagram", image: instagramIcon },
              { name: "linkedIn", image: linkedInIcon },
              { name: "tiktok", image: tikTokIcon },
              { name: "twitter", image: twitterIcon },
            ].map((ele, index) => {
              if (socialMedia?.[ele?.name] !== null && socialMedia?.[ele?.name] !== undefined && socialMedia?.[ele?.name] !== "")
                return (
                  <Link to={socialMedia?.[ele?.name]} className="d-flex align-items-center justify-content-center" key={index}>
                    <img src={ele?.image} alt={ele?.alt} />
                  </Link>
                );
              else return;
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
